export default function MySQL_DATE_ADD() {
  return (
    <div>
      <h2>MySQL_DATE_ADD</h2>    </div>
  );
}